(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pet-testimonials-popup"]) return;
  try {
    

window.onload = function() {
  document.getElementById('button').onclick = function() {
    document.getElementById('modalOverlay').style.display = 'none'
  };

  document.getElementById('modalOverlay').onclick = function() {
    document.getElementById('modalOverlay').style.display = 'none'
  };

	document.getElementById("modalId").style.transform = "translate(-50%, -50%) scale(1)";
};


  } catch(e) { console.error(e); }
})();
})();
